















import Vue from 'vue'
import * as am4core from '@amcharts/amcharts4/core'
import * as am4charts from '@amcharts/amcharts4/charts'
import am4themes_animated from '@amcharts/amcharts4/themes/animated'
import { ChartB2BB2CPData } from '@/model/dashboard/ChartB2BB2CPData'
import _ from 'lodash'
import moment from 'moment'

am4core.useTheme(am4themes_animated)

interface ComponentData {
  chart: any
  minYear: number
  maxYear: number
  selectedYear: number
  chartData: any | null
}

export default Vue.extend({
  name: 'PieChartB2BB2C',

  props: {
    pieChartB2BB2CLabel: String,
    pieChartB2BB2CData: {
      type: Array as () => Array<ChartB2BB2CPData>
    }
  },

  data (): ComponentData {
    return {
      chart: undefined,
      minYear: parseInt(moment().format('YYYY')),
      maxYear: parseInt(moment().format('YYYY')),
      selectedYear: parseInt(moment().format('YYYY')),
      chartData: null
    }
  },

  methods: {
    onBeforeClick (): void {
      this.selectedYear = this.selectedYear - 1
      this.createChart()
    },

    onNextClick (): void {
      this.selectedYear = this.selectedYear + 1
      this.createChart()
    },

    createChart (): any {
      //@ts-ignore
      let chart = am4core.create(this.$refs.pieChart, am4charts.PieChart)

      // Add data
      const data: any = [
        { name: 'B2B', value: null },
        { name: 'B2C', value: null }
      ]

      if(this.chartData[this.selectedYear]) {

        this.chartData[this.selectedYear].forEach((i: ChartB2BB2CPData) => {
          if (i.privateAddress === '0') {
            data[0].value = i.sum
          } else if (i.privateAddress === '1') {
            data[1].value = i.sum
          }
        })

        chart.data = data
      }

      // Add and configure Series
      let pieSeries = chart.series.push(new am4charts.PieSeries())
      pieSeries.dataFields.value = 'value'
      pieSeries.dataFields.category = 'name'

      // Let's cut a hole in our Pie chart the size of 40% the radius
      chart.innerRadius = am4core.percent(40)

      // Disable ticks and labels
      pieSeries.labels.template.disabled = true
      pieSeries.ticks.template.disabled = true
      pieSeries.alignLabels = false
      am4core.percent(-40)
      pieSeries.slices.template.fillOpacity = 1

      let hs = pieSeries.slices.template.states.getKey('hover')
      hs.properties.scale = 1
      hs.properties.fillOpacity = 0.5

      // Add a legend
      chart.legend = new am4charts.Legend()

      pieSeries.colors.list = [
        am4core.color('#0b7dda'),
        am4core.color('#03b237'),
      ]

      this.chart = chart
    }
  },

  mounted () {
    this.chartData = _.groupBy(this.pieChartB2BB2CData, 'year')

    const years = Object.keys(this.chartData).map(Number)
    this.minYear = Math.min(...years)

    this.createChart()
  },

  beforeDestroy () {
    if (this.chart) {
      this.chart.dispose()
    }
  }

})
